// src/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from './firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState('');
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);

        const userDocRef = doc(db, 'users', user.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          setUserRole(userData.role);
          setUserName(userData.name);
        }

        if (user.emailVerified && userDocSnap.exists()) {
          try {
            await updateDoc(userDocRef, { emailVerified: true });
          } catch (error) {
            console.error('Error al actualizar el estado de verificación de correo:', error);
          }
        }
      } else {
        setCurrentUser(null);
        setUserRole('');
        setUserName('');
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const hasRole = (requiredRole) => {
    if (!userRole) return false;
    if (requiredRole === 'super_admin') return userRole === 'super_admin';
    if (requiredRole === 'admin') return userRole === 'admin' || userRole === 'super_admin';
    if (requiredRole === 'user') return true;
    return false;
  };

  const value = {
    currentUser,
    userRole,
    userName,
    hasRole,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
